import { useEffect } from "react";
import styled, { keyframes } from "styled-components";

const BankIdStart = () => {
    useEffect(() => {
        const orderRef = sessionStorage.getItem("bankid_orderRef");
        const autoStartToken = sessionStorage.getItem("bankid_autoStartToken");

        if (!autoStartToken) {
            console.error("No autoStartToken found.");
            return;
        }

        // const redirectUrl = `https://handla.ziplink.se/bankid-complete?orderRef=${orderRef}`;

        const baseUrl = window.location.origin; // automatically picks dev or prod
        const redirectUrl = `${baseUrl}/bankid-complete?orderRef=${orderRef}`;

        console.log("[BankID Start] Opening BankID app with redirect...");

        window.location.href = `bankid:///?autostarttoken=${autoStartToken}&redirect=${redirectUrl}`;
    }, []);

    return (
        <Container>
            <Content>
                <Heading>
                    Öppnar BankID...
                    <Spinner />
                </Heading>
                <SubText>Vänligen vänta</SubText>
            </Content>
        </Container>
    );
};

export default BankIdStart;

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #000; /* dark background */
`;

const Content = styled.div`
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 28px;
  color: #fff; /* white text */
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SubText = styled.p`
  font-size: 18px;
  color: #ccc; /* slightly lighter text */
`;

// Animation for spinner
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 3px solid #fff;
  border-top: 3px solid #555;
  border-radius: 50%;
  margin-left: 10px;
  animation: ${spin} 1s linear infinite;
`;
